export enum RccapPackaging {    
    Labelling = 0,
    Contents = 1,
    Packaging = 2,
    Other = 3
}